import React, { useEffect, useRef, useState, useContext, useMemo } from "react";
import { DrawerContext } from "@src/screens/drawer-screens/drawer-provider";
import { View, ScrollView, useWindowDimensions, Linking } from "react-native";
import useStyles from "../banner-new/styles.css";
import BannerBackground from "./background-image";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectSubscriptionName } from "@src/ducks/slices/user.slice";
import { selectedDrawerStatus } from "@src/ducks/slices/dashboard.slice";
import images from "@assets/images";

// const { width: SCREEN_WIDTH } = Dimensions.get("window");

const Banner = () => {
  const styles = useStyles();
  const { width } = useWindowDimensions()
  const { onActiveTab } = useContext(DrawerContext);
  const drawerEnable = useAppSelector(selectedDrawerStatus);
  const subscriptionName = useAppSelector(selectSubscriptionName).toLowerCase();
  const [shouldShow, setShouldShow] = useState(false);
  const scrollRef = useRef<ScrollView>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isSubscriptionCustomPlan = subscriptionName === "custom"
  const bannerImages = isSubscriptionCustomPlan ? [
    {
      image: images.bg_banner_five,
      title: "Get Ready for NotarizeIT",
      description: "Find out how online notarization will affect your practice, business, and daily life. Reserve your spot in our info sessions to stay ahead.",
      button: {
        size: 0.4,
        type: "button",
        title: "Join our info sessions",
        onPress: () => {
          const url = 'https://notarizeit.ph/#contact-form';
          Linking.openURL(url).catch(err => console.error("Failed to open URL:", err));
        }
      }
    },
  ] : (subscriptionName.includes("free") || subscriptionName.includes("pro") || subscriptionName.includes("business") ) ? [
    {
      image: images.bg_banner_four,
      title: "Upgrade now to enjoy all features of SignSecure!",
      description: "Create, manage, and send multiple documents with better storage when you upgrade.",
      button: {
        type: "button",
        title: "Upgrade Now",
        onPress: () => onActiveTab("Upgrade Plan")
      }
    },
  ] : [];
  const banners = useMemo(() => {
    return bannerImages.length > 1
      ? new Array(10).fill(bannerImages).flat()
      : bannerImages;
  }, [bannerImages]);
  // useRef to keep track of currentIndex without triggering re-renders
  const currentIndexRef = useRef(0);

  useEffect(() => {
    if (bannerImages.length > 0) {
      setTimeout(() => setShouldShow(true), 300);
    }
  }, [isSubscriptionCustomPlan]);

  useEffect(() => {
    if (!shouldShow || bannerImages.length <= 1) return;
  
    const SLIDE_WIDTH = width * (drawerEnable ? 0.7 : 0.9);
    const intervalId = setInterval(() => {
      let nextIndex = currentIndexRef.current + 1;
      if (nextIndex >= banners.length) {
        nextIndex = 0;
      }
  
      // Scroll to the next index
      if (scrollRef.current) {
        scrollRef.current.scrollTo({
          x: nextIndex * SLIDE_WIDTH,
          animated: nextIndex !== 0,
        });
      }
  
      currentIndexRef.current = nextIndex;
      setCurrentIndex(nextIndex);
    }, 4000);
  
    return () => {
      clearInterval(intervalId); // ✅ always clear previous interval
    };
  }, [shouldShow, width, drawerEnable]); // ✅ only depends on values that actually affect scroll
  
  

  return (
    <>
      {shouldShow && (
        <View style={styles.containerStyle}>
          <ScrollView
            ref={scrollRef}
            horizontal
            pagingEnabled
            scrollEnabled={false}
            showsHorizontalScrollIndicator={false}
            scrollEventThrottle={16}
            onScroll={(event) => {
              const x = event.nativeEvent.contentOffset.x;
              const newIndex = Math.round(x / width);
              if (newIndex !== currentIndex) {
                setCurrentIndex(newIndex);
                currentIndexRef.current = newIndex; // sync ref with manual scroll
              }
            }}
            style={styles.flexBannerContainer}
          >
            {banners.map((item, index) => (
              <BannerBackground key={index} {...item} />
            ))}
          </ScrollView>
        </View>
      )}
    </>
  );
};

export default React.memo(Banner);